import { render, staticRenderFns } from "./pcA.vue?vue&type=template&id=f343a78a&scoped=true&"
import script from "./pcA.vue?vue&type=script&lang=js&"
export * from "./pcA.vue?vue&type=script&lang=js&"
import style0 from "./pcA.vue?vue&type=style&index=0&id=f343a78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f343a78a",
  null
  
)

export default component.exports